<template>
  <div>
    <PCNavbar selectIndex="7-1" />
    <MobileNavBar :currentActive="6" />
    <div class="enter_innovation_wrap">
      <div class="enter_img">
        <div class="img_tit hidden-xs-only">
          <div>全生命周期碳排放趋近于零</br>从源头切断污染链</div>
          <div class="content">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;氢能的核心优势在于其清洁的能量转化过程。当氢能通过燃料电池或燃烧方式释放能量时，终端产物仅有水（H₂O），不会产生二氧化碳（CO₂）、二氧化硫（SO₂）、氮氧化物（NOₓ）等污染物，从能源使用环节实现了 “零碳排放”。更关键的是，随着 “绿氢” 技术的成熟，氢能的全生命周期碳排放进一步降低 —— 绿氢以可再生能源（如风电、光伏、水电）为动力，通过电解水制备氢气，整个过程完全不依赖化石燃料，从 “生产 - 储运 - 使用” 全链条实现了碳排放闭环控制。​
相比之下，传统化石能源（煤炭、石油、天然气）不仅在燃烧环节会大量排放 CO₂（如 1 吨标准煤燃烧约产生 2.6 吨 CO₂），其开采、加工、运输过程还会伴随额外的碳排放（如石油开采中的伴生气泄漏、煤炭运输中的能量消耗）。而氢能尤其是绿氢，彻底摆脱了对化石能源的依赖，从源头切断了碳排放的链条，为实现 “净零排放” 提供了根本解决方案。
          </div>
        </div>
        <div class="img_tit hidden-sm-and-up">
          <div>全生命周期碳排放趋近于零</br>从源头切断污染链</div>
          <div class="content">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;氢能的核心优势在于其清洁的能量转化过程。当氢能通过燃料电池或燃烧方式释放能量时，终端产物仅有水（H₂O），不会产生二氧化碳（CO₂）、二氧化硫（SO₂）、氮氧化物（NOₓ）等污染物，从能源使用环节实现了 “零碳排放”。更关键的是，随着 “绿氢” 技术的成熟，氢能的全生命周期碳排放进一步降低 —— 绿氢以可再生能源（如风电、光伏、水电）为动力，通过电解水制备氢气，整个过程完全不依赖化石燃料，从 “生产 - 储运 - 使用” 全链条实现了碳排放闭环控制。​
相比之下，传统化石能源（煤炭、石油、天然气）不仅在燃烧环节会大量排放 CO₂（如 1 吨标准煤燃烧约产生 2.6 吨 CO₂），其开采、加工、运输过程还会伴随额外的碳排放（如石油开采中的伴生气泄漏、煤炭运输中的能量消耗）。而氢能尤其是绿氢，彻底摆脱了对化石能源的依赖，从源头切断了碳排放的链条，为实现 “净零排放” 提供了根本解决方案。
          </div>
        </div>
      </div>
      <div class="right">
        <img src="@/assets/wuran.webp" alt="">
      </div>
    </div>
    <div class="enter_innovation_wrap1 enter_innovation_wrap">
      <div class="right">
        <img src="@/assets/wh.webp" alt="">
      </div>
      <div class="enter_img">
        <div class="img_tit hidden-xs-only"> 
          <div>适配多场景减排需求</br>填补传统清洁能源短板</div>
          <div class="content">
<p> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;氢能的灵活性使其能覆盖多个高碳排放领域，填补传统清洁能源（如电能）在应用场景上的空白，成为跨领域减排的 “万能钥匙”</p>
<p> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在交通运输领域，氢能可解决新能源汽车的 “续航焦虑” 与 “补能效率” 难题。氢燃料电池汽车续航里程可达 600-1000 公里，加氢时间仅需 3-5 分钟，远超纯电动汽车的充电效率。</p>
<p> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在工业领域，氢能可替代化石能源实现 “绿色生产”。工业是全球碳排放的主要来源之一（占比约 35%），其中钢铁、化工、水泥等行业的 “工艺性碳排放”（如钢铁生产中焦炭的燃烧）难以通过电能替代。而氢能可作为还原剂和燃料，直接应用于工业生产。</p>
<p> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在能源存储与电网调峰领域，氢能可助力可再生能源消纳，间接减少碳排放。风电、光伏等可再生能源存在 “间歇性”“波动性” 问题，大量电能无法直接并网（全球每年约有 20% 的可再生能源电力因消纳难题被浪费），而氢能可通过 “电解水制氢” 将多余电能转化为化学能存储，再通过燃料电池或燃气轮机将氢能转化为电能或热能，实现 “风光氢储” 一体化。</p>
          </div>
        </div>
        <div class="img_tit hidden-sm-and-up">
          <div>适配多场景减排需求</br>填补传统清洁能源短板</div>
          <div class="content">
<p> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;氢能的灵活性使其能覆盖多个高碳排放领域，填补传统清洁能源（如电能）在应用场景上的空白，成为跨领域减排的 “万能钥匙”</p>
<p> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在交通运输领域，氢能可解决新能源汽车的 “续航焦虑” 与 “补能效率” 难题。氢燃料电池汽车续航里程可达 600-1000 公里，加氢时间仅需 3-5 分钟，远超纯电动汽车的充电效率。</p>
<p> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在工业领域，氢能可替代化石能源实现 “绿色生产”。工业是全球碳排放的主要来源之一（占比约 35%），其中钢铁、化工、水泥等行业的 “工艺性碳排放”（如钢铁生产中焦炭的燃烧）难以通过电能替代。而氢能可作为还原剂和燃料，直接应用于工业生产。</p>
<p> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在能源存储与电网调峰领域，氢能可助力可再生能源消纳，间接减少碳排放。风电、光伏等可再生能源存在 “间歇性”“波动性” 问题，大量电能无法直接并网（全球每年约有 20% 的可再生能源电力因消纳难题被浪费），而氢能可通过 “电解水制氢” 将多余电能转化为化学能存储，再通过燃料电池或燃气轮机将氢能转化为电能或热能，实现 “风光氢储” 一体化。</p>
          </div>
        </div>
      </div>
    </div>
    <div class="enter_innovation_wrap2 enter_innovation_wrap">
      <div class="enter_img">
        <div class="img_tit hidden-xs-only">
          <div>对比传统能源与其他清洁能源</br>氢能减排优势更显著</div>
          <div class="content">
<p> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;与传统化石能源相比，氢能的减排效果无需多言 —— 以供暖为例，1 吨氢能供暖的碳排放约为 0，而 1 吨天然气供暖约排放 2.7 吨 CO₂，1 吨煤炭供暖约排放 4.1 吨 CO₂，氢能的减排优势堪称 “量级碾压”。</p>
<p> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;即使与其他清洁能源（如电能、生物质能）相比，氢能的减排价值仍有突出亮点。电能虽清洁，但依赖于发电端的能源结构 —— 若电能来自煤电，其全生命周期碳排放（约 0.8 公斤 / 度）并不低于部分氢能应用（如绿氢制电）；而生物质能存在 “与人争粮”“与林争地” 的问题，且其燃烧过程仍会产生少量 CO₂和污染物。氢能则无此类限制：绿氢制备仅需水和可再生能源，不占用耕地资源，且全生命周期碳排放几乎为零，是真正意义上的 “无负担清洁能源”。</p>
          </div>
        </div>
        <div class="img_tit hidden-sm-and-up"><div>对比传统能源与其他清洁能源</br>氢能减排优势更显著</div>
          <div class="content">
<p> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;与传统化石能源相比，氢能的减排效果无需多言 —— 以供暖为例，1 吨氢能供暖的碳排放约为 0，而 1 吨天然气供暖约排放 2.7 吨 CO₂，1 吨煤炭供暖约排放 4.1 吨 CO₂，氢能的减排优势堪称 “量级碾压”。</p>
<p> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;即使与其他清洁能源（如电能、生物质能）相比，氢能的减排价值仍有突出亮点。电能虽清洁，但依赖于发电端的能源结构 —— 若电能来自煤电，其全生命周期碳排放（约 0.8 公斤 / 度）并不低于部分氢能应用（如绿氢制电）；而生物质能存在 “与人争粮”“与林争地” 的问题，且其燃烧过程仍会产生少量 CO₂和污染物。氢能则无此类限制：绿氢制备仅需水和可再生能源，不占用耕地资源，且全生命周期碳排放几乎为零，是真正意义上的 “无负担清洁能源”。</p>
          </div></div>
      </div>
      <div class="right">
        <img src="@/assets/h2.webp" alt="">
      </div>
    </div>
    <CallMe />
    <MobileCallme />
  </div>
</template>

<script>
import PCNavbar from "@/components/navbar/index";
import MobileNavBar from "@/components/navbar/MobileNavBar.vue";
import CallMe from "@/components/callme/index";
import MobileCallme from "@/components/callme/MobileCallme.vue";
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    CallMe,
    MobileCallme,
  },
};
</script>

<style lang="scss" scoped>
.enter_innovation_wrap {
  margin-top: 70px;
  width: 100%;
  background: url("../../assets/green.png") 0 0 no-repeat;
  background-size: 100% 100%;
  display: flex;
  .enter_img {
    width: 50%;
    height: 600px;
    padding: 120px 0 0 120px;
    @media screen and (max-width: 768px) {
      width: 100%;
      height: 180px;
      padding: 30px 0 0 30px;
    }
    color: #000;
    .img_tit {
      font-size: 30px;
      font-weight: bold;
      @media screen and (max-width: 768px) {
        font-size: 0.6rem;
      }
      .content {
        margin-top: 20px;
        font-size: 20px;
        font-weight: normal;
         @media screen and (max-width: 768px) {
        font-size: 0.4rem;
      }
      }
    }
  }
  .right {
    width: 50%;
    height: 600px;
    display: flex;
    justify-content: center;
    align-items: center;
    @media screen and (max-width: 768px) {
      width: 30%;
    }
    img {
      border-radius: 20px;
      width: 60% !important;
    }
  }
}
.enter_innovation_wrap1 {
  background: #fff;
  .enter_img {
    padding: 120px 120px 0 0;
  }
}
.enter_innovation_wrap2 {
  background: #e4edf3;
}
</style>